/* eslint-disable no-console  -- logger */
import pkg from "google-libphonenumber";

const { PhoneNumberUtil } = pkg;

// Returns the countryCode for a phoneNumber
export const countryCodeShaper = (phone: string): string | undefined => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    const phoneNumber = phoneUtil.parse(phone);
    const countryCode = phoneNumber.getCountryCode();
    return `+${countryCode}`;
  } catch (e) {
    // Empty catch block to handle linting errors
  }
};

// Returns the phone number from phone -> countryCode + phoneNumber
export const phoneNumberShaper = (phone: string): string => {
  const countryCodeResult = countryCodeShaper(phone) || "";
  const countryCode = countryCodeResult.replace("+", "") || "";

  let modifiedPhone = phone.trim().replace("+", "") || "";
  modifiedPhone = modifiedPhone.startsWith(countryCode)
    ? modifiedPhone.replace(countryCode, "")
    : modifiedPhone;

  return modifiedPhone;
};

// Checks if the phone number is valid with respect to the countryCode / region
export const isPhoneNumberValid = (
  phoneNumber: string,
  countryCode?: string,
): boolean => {
  const phoneNumberRegex = /^\+?[0-9]+$/;
  if (!phoneNumberRegex.test(phoneNumber)) return false;
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode);
    const regionCode = phoneUtil.getRegionCodeForNumber(number);
    const isValidNumber = phoneUtil.isValidNumberForRegion(
      number,
      regionCode || countryCode,
    );
    return isValidNumber;
  } catch (error) {
    console.error("Error validating phone number", error);

    return false;
  }
};
